import React from "react";
import { Box, Typography, Button } from "@mui/material";

const NominateIgniteTalkSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#2B0A5A",
        px: { xs: 3, md: 6 },
        py: { xs: 5, md: 7 },
      }}
    >
      <Box
        className="nominate-ignite-wrap"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          maxWidth: 900,
          mx: "auto",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/nominate-sideimg-new.png`}
          alt="ignite thunder"
          sx={{
            width: "30%",
            flexShrink: 0,
          }}
        />

        <Box>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/nominate-ignitetalks.png`}
            alt="ignite thunder"
            sx={{
              width: "50%",
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: 22, md: 30 },
              fontWeight: 700,
              mb: 1,
            }}
          >
            Nominate yourself for the Ignite Talk
          </Typography>

          <Typography
            sx={{
              color: "#E0D7FF",
              fontSize: 14,
              lineHeight: 1.6,
              mb: 3,
              maxWidth: 520,
            }}
          >
            Want to contribute to our culture of knowledge sharing? Nominate
            yourself or a colleague to present in our IgniteTalks series and
            help inspire the SONG community.
          </Typography>

          <Button
            component="a"
            // href="https://myoffice.accenture.com/:x:/g/personal/a_kaur_g_bhatia_accenture_com/IQDTo3SAqC7CT7HY_knA3ITtASZrsAB1BpFpTk0WELDhHgs?e=M8840v"
            href="https://forms.office.com/pages/responsepage.aspx?id=OT154DkJbUmxKRmO3ZFv6-f6l1xahKtLhVmUj7RGElBURVpOMEY1N05YT1UyS0lMN1JWRUZVMVJINC4u&route=shorturl"
            target="_blank"
            variant="contained"
            sx={{
              backgroundColor: "#fff",
              textTransform: "capitalize",
              color: "#000",
              fontWeight: 600,
              px: 4,
              py: 1.2,
              borderRadius: 0,
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            startIcon={<span style={{ fontSize: 18 }}>→</span>}
          >
            Nominate
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NominateIgniteTalkSection;
